import React from 'react';

import './styles/_new-tag.scss';

import CustomTooltip from '../common-components/CustomTooltip/CustomTooltip';

interface Props {
  title?: string;
  tooltipText?: string;
}

const NewTag = ({ title = 'New', tooltipText }: Props) => {
  return (
    <CustomTooltip title={tooltipText} show={Boolean(tooltipText)}>
      <span className="new-tag">{title}</span>
    </CustomTooltip>
  );
};

export default NewTag;
